import axios from 'axios'
import url from '../baseUrl'

let baseUrl = url.salaryUrl


const addFile = baseUrl + "/storage/addFile?createAccount=";
const $ajaxAddFile = params => axios.post(baseUrl + '/storage/addFile', params);
const $axiosGetAllCityStation = params => axios.get(baseUrl + '/cityStation/getall', { params });
// 查询新增汇总
const $axiosSelectSalarySummary = params => axios.get(baseUrl + '/salary/selectSalarySummary', { params });
// 新农村保险列表
const $axiosNewSocialInsureList = params => axios.get(baseUrl + '/salary/newSocialInsureList', { params });
// 新农村保险导入
const $axiosImportNewSocialInsure = params => axios.post(baseUrl + '/salary/importNewSocialInsure', params);
// 杂费列表
const $axiosOtherFeeList = params => axios.get(baseUrl + '/salary/otherFeeList', { params });
// 杂费明细导入
const $axiosImportOtherFee = params => axios.post(baseUrl + '/salary/importOtherFee', params);
// 薪资标签列表
const $axiosGetSalaryLabelList = params => axios.get(baseUrl + '/worker/getSalaryLabelList', { params });
// 根据城市或服务站获取服务者
const $axiosGetWorkerList = params => axios.get(baseUrl + '/worker/getWorkerList', { params });
// 取消服务者薪资标签
const $axiosCancelLabel = params => axios.get(baseUrl + '/worker/cancelLabel', { params });
// 服务者薪资标签新增
const $axiosAddSalaryLabel = params => axios.post(baseUrl + '/worker/addSalaryLabel', params);
// 审核服务者薪资标签
const $axiosLabelPpprove = params => axios.post(baseUrl + '/worker/labelPpprove', params);
// 修改服务者薪资标签
const $axiosUpdateSalaryLabel = params => axios.post(baseUrl + '/worker/updateSalaryLabel', params);
// 修改服务者薪资标签
const $axiosAuditList = params => axios.get(baseUrl + '/complain/auditList', { params });
// 处理审核 complain/processAudit
const $axiosProcessAudit = params => axios.get(baseUrl + '/complain/processAudit', { params });
// 审核轨迹 complain/auditDetail
const $axiosAuditDetail = params => axios.get(baseUrl + '/complain/auditDetail', { params });
// 发起申诉   /complain/addNewComplain
const $axiosAddNewComplain = params => axios.get(baseUrl + '/complain/addNewComplain', { params });
// 查询基础信息和，某月分类汇总薪资 /salary/selectMonthTypeSalary
const $axiosNewSelectMonthTypeSalary = params => axios.get(baseUrl + '/salary/selectMonthTypeSalary', { params });

// 查询服务站列表 /cityStation/getStationPageList
const $axiosGetStationPageList = params => axios.get(baseUrl + '/cityStation/getStationPageList', { params });
// 删除服务站 /cityStation/deleteStation
const $axiosDeleteStation = params => axios.get(baseUrl + '/cityStation/deleteStation', { params });
// 获取所有用户下拉框 /sysUser/getallUser
const $axiosSysUsergetallUser = params => axios.get(baseUrl + '/sysUser/getallUser', { params });
// 获取所有用户下拉框 /sysUser/getallUser
const $axiosUpdateStationAdmin = params => axios.get(baseUrl + '/cityStation/updateStationAdmin', { params });
// 城市驿站服务站tree***用这个三级联动
const $axioSysUserGetTreeAllData = params => axios.get(baseUrl + '/cityStation/getTreeAllData', { params });

// 根据id查询服务站
const $axioSelectstationbyid = params => axios.get(baseUrl + '/cityStation/selectstationbyid', { params });
// 修改服务站的区域
const $axioUpdateStationRegion = params => axios.post(baseUrl + '/cityStation/updateStationRegion', params);

// 查询薪资明细列表 jzworkerapiservice/salary/selectSalaryDetailPage
const $axiosSelectSalaryDetailPage = params => axios.get(baseUrl + '/salary/selectSalaryDetailPage', { params });
// 查询新增类型字典数据 jzworkerapiservice/salary/getAllSalaryType
const $axiosGetAllSalaryType = params => axios.get(baseUrl + '/salary/getAllSalaryType', { params });

// 薪资类型导入
const $axiosimportWorkerSalary = params => axios.post(baseUrl + '/salary/importWorkerSalary', params);
// 查询阿姨核酸完成情况/jzworkerapiservice/nucleic/nucleicList
const $axiosNucleicList = params => axios.post(baseUrl + '/nucleic/nucleicList', params );
// 查询某个阿姨月度核酸完成情况/jzworkerapiservice/nucleic/nucleicDetail
const $axiosNucleicDetail = params => axios.get(baseUrl + '/nucleic/nucleicDetail', { params });

//品类预检单
const $axioslistPre = params => axios.get(baseUrl + '/preorder/list', { params });
const $axiosdetailOrder = params => axios.get(baseUrl + '/preorder/detail', { params });
const $axioslistPreCategory = params => axios.get(baseUrl + '/preCategory/list', { params });
const $axiosdetailPreCategory = params => axios.get(baseUrl + '/preCategory/detail', { params });
const $axiosdeletePreCategory = params => axios.get(baseUrl + '/preCategory/delete', { params });
const $axiosaddPreCategory = params => axios.get(baseUrl + '/preCategory/add', { params });
const $axiosdeleteTypePreCategory = params => axios.get(baseUrl + '/preCategory/typeDelete', { params });
const $axiosaddTypePreCategory = params => axios.get(baseUrl + '/preCategory/typeAdd', { params });
//保洁预检列表查询
const $axiosprebjorderList = params => axios.get(baseUrl + '/prebjorder/list', { params });
const $axiosprebjorderDetail = params => axios.get(baseUrl + '/prebjorder/detail', { params });

//服务者通知 消息
const $axioWorkerNoticeGetPageList = params => axios.post(baseUrl + '/workerNotice/getPageList', params);
//发送消息
const $axioWorkerNoticeSendNotice = params => axios.post(baseUrl + '/workerNotice/sendNotice', params);
//消息类型
const $axioWorkerNoticeGetTypelist = params => axios.get(baseUrl + '/workerNotice/getTypelist', { params });
//删除消息
const $axioWorkerNoticeDeleteById = params => axios.get(baseUrl + '/workerNotice/deleteById', { params });
const $axioWorkerNoticeDeleteByBatchNo = params => axios.get(baseUrl + '/workerNotice/deleteByBatchNo', { params });
//代替阅读消息
const $axioWorkerReadNotice = params => axios.get(baseUrl + '/workerNotice/readNotice', { params });

//查询小程序路径页面
const $axioGetAppPagelist = params => axios.get(baseUrl + '/workerNotice/getAppPagelist', { params });

//服务者系统操作日志
const  $axioSysLogGetPageList = params => axios.get(baseUrl + '/systemLog/logList', {params});

//公众号管理 消息
const $axioWxMpTemplateList = params => axios.get(baseUrl + '/wxMpTemplate/getPageList', {params});
const $axioWxAddTempLate = params => axios.post(baseUrl + '/wxMpTemplate/addTempLate', params);
const $axioWxMpTemplateDel = params => axios.get(baseUrl + '/wxMpTemplate/deleted', {params});
const $axioWxEditTempLate = params => axios.post(baseUrl + '/wxMpTemplate/updateTempLate', params);
const $axioWxMpGetAll = params => axios.get(baseUrl + '/wxMpTemplate/getAll', {params});
const $axioWxMpJobList = params => axios.get(baseUrl + '/wxMpJob/getPageList', {params});
const $axioWxAddJob = params => axios.post(baseUrl + '/wxMpJob/addJob', params);
const $axioWxUpdateJob = params => axios.post(baseUrl + '/wxMpJob/updateJob', params);
const $axioWxMpJobDel = params => axios.get(baseUrl + '/wxMpJob/deleted', {params});
const $axioWxMpGetDefaultField = params => axios.get(baseUrl + '/wxMpTemplate/getDefaultField', {params});
const $axioDimMpGetAll = params => axios.get(baseUrl + '/dimLabel/getAll', {params});
const $axioWxSyncAllWxUser = params => axios.get(baseUrl + '/wxMpJob/syncAllWxUser', {params});
const $axioWxGetLog = params => axios.get(baseUrl + '/wxMpJob/getLog', {params});
const $axioWXGetAllJobList = params => axios.get(baseUrl + '/wxMpJob/getAllJobList', {params});

// 朝朝盈
// /jzworkerapiservice/workerSupplier/setZzy 设置招招盈资格 0否 1是
const $axioSetZzy = params => axios.get(baseUrl + '/workerSupplier/setZzy', {params});
// /jzworkerapiservice/workerSupplier/pauseZzy 暂停或取消暂停招招盈资格 1暂停 0取消暂停
const $axioPauseZzy = params => axios.get(baseUrl + '/workerSupplier/pauseZzy', {params});
// /jzworkerapiservice/workerSupplier/getShareRecord 查看分享记录
const $axioGetShareRecord = params => axios.get(baseUrl + '/workerSupplier/getShareRecord', {params});
///jzworkerapiservice/workerSupplier/getZzyList 招招盈关系列表
const $axioGetZzyList = params => axios.get(baseUrl + '/workerSupplier/getZzyList', {params});
// /jzworkerapiservice/workerSupplier/getPauseHistory 查看暂停操作历史
const $axioGetPauseHistory = params => axios.get(baseUrl + '/workerSupplier/getPauseHistory', {params});
//审核拒绝原因
const $axioGetRefuseContent = params => axios.get(baseUrl + '/worker/getAuditReason', {params});

export default {
    addFile,
    $ajaxAddFile,
    $axiosGetAllCityStation,
    $axiosSelectSalarySummary,
    $axiosNewSocialInsureList,
    $axiosImportNewSocialInsure,
    $axiosOtherFeeList,
    $axiosImportOtherFee,
    $axiosGetSalaryLabelList,
    $axiosGetWorkerList,
    $axiosCancelLabel,
    $axiosAddSalaryLabel,
    $axiosLabelPpprove,
    $axiosUpdateSalaryLabel,
    $axiosAuditList,
    $axiosProcessAudit,
    $axiosAuditDetail,
    $axiosAddNewComplain,
    $axiosNewSelectMonthTypeSalary,
    $axiosGetStationPageList,
    $axiosSysUsergetallUser,
    $axiosUpdateStationAdmin,
    $axioSysUserGetTreeAllData,
    $axioSelectstationbyid,
    $axioUpdateStationRegion,

    $axiosSelectSalaryDetailPage,
    $axiosGetAllSalaryType,
    $axiosimportWorkerSalary,
    $axiosDeleteStation,
    $axiosNucleicList,
    $axiosNucleicDetail,
    $axioslistPreCategory,
    $axiosdetailOrder,
    $axioslistPre,
    $axiosdetailPreCategory,
    $axiosdeletePreCategory,
    $axiosaddPreCategory,
    $axiosdeleteTypePreCategory,
    $axiosaddTypePreCategory,
    $axiosprebjorderList,
    $axiosprebjorderDetail,

    $axioWorkerNoticeGetPageList,
    $axioWorkerNoticeSendNotice,
    $axioWorkerNoticeGetTypelist,
    $axioWorkerNoticeDeleteById,
    $axioWorkerNoticeDeleteByBatchNo,
    $axioWorkerReadNotice,
    $axioGetAppPagelist,

    $axioSysLogGetPageList,
    $axioWxMpTemplateList,
    $axioWxAddTempLate,
    $axioWxMpTemplateDel,
    $axioWxEditTempLate,
    $axioWxMpGetAll,
    $axioWxMpJobList,
    $axioWxAddJob,
    $axioWxUpdateJob,
    $axioWxMpJobDel,
    $axioWxMpGetDefaultField,
    $axioDimMpGetAll,
    $axioWxSyncAllWxUser,
    $axioWxGetLog,
    $axioWXGetAllJobList,

    $axioSetZzy,
    $axioPauseZzy,
    $axioGetShareRecord,
    $axioGetZzyList,
    $axioGetPauseHistory,
    $axioGetRefuseContent

}
